import React, { useState } from 'react';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import useDebouncedValue from 'hooks/useDebouncedValue';

const defaultFilter = createFilterOptions();

// MUI keeps the typed text and selection immediate while option filtering waits.
export default function DebouncedAutocomplete({ filterOptions = defaultFilter, onInputChange, ...props }) {
    const [input, setInput] = useState('');
    const query = useDebouncedValue(input);
    return (
        <Autocomplete
            {...props}
            onInputChange={(event, value, reason) => {
                setInput(value);
                if (onInputChange) onInputChange(event, value, reason);
            }}
            filterOptions={(options, state) => filterOptions(options, { ...state, inputValue: query })}
        />
    );
}
